<div class="chance-detail" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
    <img src="assets/spaces/chance.png" height="120">
    <div style="text-align: center;">
        <!-- <h1>Chance ?</h1> -->
        <h2>{{text}}</h2>
    </div>
</div>
